import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useGetAudienceCustomers } from "../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../..";
import { useState } from "react";

export const TotalRecipients = ({ smsCampaign = {}, isAudience = false }) => {
  const [queryParams] = useState({ per_page: 300 });
  const recipient_phone_numbers = smsCampaign?.recipient_phone_numbers || [];
  const customers = smsCampaign?.customers;

  const { data: customerData, isLoading } = useGetAudienceCustomers({
    id: smsCampaign?.audience?.id,
    queryParams,
    isEnabled: smsCampaign?.audience?.id ? true : false,
  });
  const audienceCustomers = customerData?.data || [];

  return (
    <div className="d-flex flex-column" style={{ gap: "30px" }}>
      <secondaryComponents.LoaderHelper
        isLoading={isLoading}
        classNames={"mt-4"}
      >
        <div>
          <h5>Audience Group ({audienceCustomers?.length})</h5>

          <div className={`${globalStyles.cardWithBackground}`}>
            <p className="d-flex flex-wrap" style={{ gap: "10px" }}>
              {audienceCustomers?.map((customer) => (
                <span
                  className={`${globalStyles["statusBlock"]} dark--text`}
                  key={customer?.id}
                >
                  {customer?.full_name}
                </span>
              ))}
            </p>
          </div>
        </div>

        {!isAudience ? (
          <>
            <div>
              <h5>Contact List ({customers?.length})</h5>

              <div className={`${globalStyles.cardWithBackground}`}>
                <p>
                  {customers
                    ?.map((customer) => customer?.full_name)
                    ?.join(", ")}
                </p>
              </div>
            </div>

            <div>
              <h5>Manual Entry ({recipient_phone_numbers?.length})</h5>

              <div className={`${globalStyles.cardWithBackground}`}>
                <p>{recipient_phone_numbers?.join(", ")}</p>
              </div>
            </div>
          </>
        ) : null}
      </secondaryComponents.LoaderHelper>
    </div>
  );
};
